<template>
  <div class="modal-content">
    <div class="service-box">
      <img src="~@/assets/image/kehufuwu.png" class="service-icon" />
    </div>
    <div class="hotline">客服热线：{{ customer_service_phone }}</div>
    <div class="service-time">客服服务时间：{{ customer_service_time }}</div>
    <div v-if="userRes.accountLevel != '1'" class="service-other">联系客服购买会员即可查看更多信息</div>
    <button class="confirm-btn" @click="handleConfirm">好的已知晓</button>
  </div>
</template>

<script>
export default {
  name: "CustomerService",
  data() {
    return {
      customer_service_phone: localStorage.getItem("customer_service_phone"),
      customer_service_time: localStorage.getItem("customer_service_time"),
      userRes: {},
    };
  },
  methods: {
    handleConfirm() {
      this.$emit("close");
    },
  },
  mounted() {
    this.userRes = JSON.parse(localStorage.getItem("userRes"));
  },
};
</script>

<style scoped>
.modal-content {
  background-color: #fff;
  border-radius: 12px;
  text-align: center;
  box-sizing: border-box;
  padding-bottom: 46px;
  padding-top: 37px;
}

.service-box {
  width: 160px;
  height: 160px;
  margin: 0 auto;
}

.service-icon {
  width: 100%;
  height: 100%;
}

.hotline {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  margin-top: 33px;
  line-height: normal;
}

.service-time {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 24px;
  margin-top: 10px;
}

.service-other {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #ff9318;
  line-height: normal;
  margin-top: 12px;
}

.confirm-btn {
  width: 276px;
  height: 60px;
  background: #1869ff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  margin-top: 39px;
}

.confirm-btn:hover {
  opacity: 0.9;
}

.confirm-btn:active {
  opacity: 0.85;
}
</style>
